export default __webpack_public_path__ + "static/media/workshop1.5e34f9b1.jpg";